import React from 'react'
import PropTypes from 'prop-types'
import { mdiCheck } from '@mdi/js'
import { Col } from 'react-bootstrap'
import classnames from 'classnames'
import { Icon, IconLabel } from '@jcu/cookbook-react'

const Step = ({ name, isAvailable, isDone, showDivider, children }) => {
  return (
    <Col
      className={classnames(
        'step text-xs-center align-items-center text-center',
        { 'step-disabled': !isAvailable }
      )}
    >
      <h2 className="step-id">
        {(isDone && (
          <IconLabel className="step-offset">
            <IconLabel.Icon className="me-1">
              <Icon path={mdiCheck} color="008a00" size="1.5rem" />
            </IconLabel.Icon>
            <IconLabel.Content>{' ' + name}</IconLabel.Content>
          </IconLabel>
        )) ||
          ' ' + name}
      </h2>
      {children}
      {showDivider && <hr className="d-md-none" />}
    </Col>
  )
}

Step.propTypes = {
  name: PropTypes.string,
  isAvailable: PropTypes.bool.isRequired,
  isDone: PropTypes.bool.isRequired,
  showDivider: PropTypes.bool,
  children: PropTypes.node,
}

Step.defaultProps = {
  isAvailable: false,
  isDone: false,
  showDivider: true,
}

export default Step
